module.exports = __webpack_public_path__ + "static/img/LSYTJ.3032155.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/LSYTJ.png
// module id = Wzro
// module chunks = 1